






















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Patient } from "../../../domain/patient";
import { ICancelableCondition } from "../../system/dialogs";
import {
  ISingleSelectableAsynchronously,
  ISingleSelectableConditionallyAsynchronously,
} from "../../system/selectors";
import { DialogMixin } from "../../system/mixins";
import PatientFinder from "../selectors/PatientFinder.vue";

@Component({
  components: {
    finder: PatientFinder,
  },
})
export default class PatientFindDialog extends Mixins(DialogMixin) implements ISingleSelectableAsynchronously<Patient>, ISingleSelectableConditionallyAsynchronously<Patient, ICancelableCondition> {
  @Prop({ default: "患者"})
  name: string;

  get title(): string {
    return this.name + "検索";
  }

  data(): any {
    return {
      patientNo: null as string,
      patientName: null as string,
      foundItem: null as Patient,
      isCancelable: true,
      shouldUseNameOnly: false,
    };
  }
  patientNo: string;
  patientName: string;
  foundItem: Patient;
  isCancelable: boolean;
  shouldUseNameOnly: boolean;

  @Watch("foundItem")
  patientUpdated(): void {
    if (this.foundItem) {
      this.isVisible = false;
    }
  }

  async selectOption(defaultOption?: Patient): Promise<Patient> {
    return this.show(defaultOption ? defaultOption.id : null);
  }

  async selectOptionConditionally(condition: ICancelableCondition, defaultOption?: Patient): Promise<Patient> {
    return this.show(defaultOption ? defaultOption.id : null, condition && condition.isCancelable);
  }

  async show(patientNo: string = null, isCancelable: boolean = false): Promise<Patient> {
    return this.showPatientFindDialog(patientNo, isCancelable, null);
  }

  async showNameSearch(): Promise<Patient> {
    return this.showPatientFindDialog(null, true, null, true);
  }

  private async showPatientFindDialog(patientNo: string, isCancelable: boolean, patientName: string, shouldUseNameOnly: boolean = false): Promise<Patient> {
    return this.showModal(async () => {
      this.patientNo = "";
      this.patientName = patientName;
      this.foundItem = null;
      this.isCancelable = isCancelable;
      this.shouldUseNameOnly = shouldUseNameOnly;
      await this.$nextTick();
      (this.$refs.finder as PatientFinder).focusToInput();
      await this.waitHidden();
      // patientNoを更新しておかないと、同じpatientNoでshow呼ばれた場合に、患者番号の前の値が残る.(PatientFinder的には変化がないから？)
      this.patientNo = this.foundItem
        ? this.foundItem.id
        : null;
      this.patientName = "";
      // キャンセルの時はundefinedを返す.PatientFinderがクリアする事はないのでnull/undefinedの場合はundefinedを返却.
      return this.foundItem
        ? this.foundItem
        : undefined;
    });
  }

  cancel(): void {
    this.isVisible = false;
  }
}
